const baseURL = "/v1/Serie";

const service = {
  methods: {
    $buscarModalidades() {
      return this.$api().get(`${baseURL}/Modalidade`);
    },
    $buscarSeries(params) {
      return this.$api().get(`${baseURL}`, params);
    },
    $visualizarSeries({ params, id }) {
      return this.$api().get(`${baseURL}/${id}`, params);
    },
    $cadastrarSerie(body) {
      return this.$api().post(`${baseURL}`, body);
    },
    $editarSerie(body, id) {
      return this.$api().put(`${baseURL}/${id}`, body);
    },
    $inativarAtivarSerie(id) {
      return this.$api().patch(`${baseURL}/${id}/AlterarStatus`);
    }
  },
};

export default service;
